<template>
	<v-card>
		<v-card-title
			>{{ $localize('ArticleImportLink.title') }}:
			{{ articleImport.originalFileName }}</v-card-title
		>
		<v-card-text v-if="articleImport">
			<v-form ref="linkingForm">
				<div class="import-wrapper">
					<table class="import-table">
						<thead>
							<tr>
								<th
									v-for="index in columnCount"
									:key="index - 1"
								>
									<v-autocomplete
										solo
										:items="links"
										item-value="id"
										item-text="text"
										v-model="articleImport.links[index - 1]"
										:rules="[
											validation.nonDuplicate,
											validation.required,
										]"
										@change="saveLinks()"
									/>
								</th>
							</tr>
							<tr
								class="preview-header"
								v-if="articleImport.hasHeader"
							>
								<th
									v-for="(column, columnIndex) in data[0]"
									:key="columnIndex"
									:class="{
										excluded:
											articleImport.links[columnIndex] ===
											'-1',
									}"
								>
									{{ column }}
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(row, index) in data" :key="index">
								<template
									v-if="index > 0 || !articleImport.hasHeader"
								>
									<td
										v-for="(column, columnIndex) in row"
										:key="index + '-' + columnIndex"
										:class="{
											excluded:
												articleImport.links[
													columnIndex
												] === '-1',
										}"
									>
										<span :title="row[column]">{{
											column
										}}</span>
									</td>
								</template>
							</tr>
						</tbody>
					</table>
				</div>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-btn @click="$emit('back')">{{
				$localize('form.button.back')
			}}</v-btn>
			<v-btn class="success" @click="confirm">{{
				$localize('form.button.confirm')
			}}</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {
	getArticleImport,
	getArticleImportData,
	getAvailableArticleImportLinks,
} from '@/services/api'
import sendCommand from '@/services/sendCommand'
import { isGuid } from '@/services/validation'
import { required } from '@/services/validation'

export default {
	props: {
		articleImportId: {
			validator: isGuid,
			required: true,
		},
	},

	data() {
		return {
			articleImport: {},
			data: [],
			links: [],

			validation: {
				required,
				nonDuplicate: (link) => {
					if (link === '-1' || !link) {
						return true
					}
					if (this.articleImport.links) {
						const linkCount = this.articleImport.links.filter(
							(x) => x === link
						).length
						if (linkCount > 1) {
							return 'Dubbele koppeling'
						}
					}
					return true
				},
			},
		}
	},
	computed: {
		columnCount() {
			if (this.data.length > 0) {
				return this.data[0].length
			}
			return 0
		},
		dataStartIndex() {
			if (this.articleImport.hasHeader) {
				return 1
			}
			return 0
		},
	},
	async created() {
		this.step = this.articleImportId ? 3 : 1
		if (this.articleImportId) {
			const { result, ok } = await getArticleImport.call({
				args: { articleImportId: this.articleImportId },
			})
			if (ok) {
				this.articleImport = result
                await this.loadData();
                await this.loadLinks();
			}
		}
	},
	methods: {
		async loadData() {
			const { result, ok } = await getArticleImportData.call({
				args: { articleImportId: this.articleImportId },
			})
			if (ok) {
				this.data = result
			}
		},
		async loadLinks() {
			const { result, ok } = await getAvailableArticleImportLinks.call({
				args: { articleImportId: this.articleImportId },
			})

			if (ok) {
				this.links = result
				this.links.splice(0, 0, {
					id: '-1',
					text: 'Niet importeren',
				})
			}
		},
		async saveLinks() {
			await sendCommand('ChangeArticleImportLinks', {
				articleImportId: this.articleImportId,
				links: this.articleImport.links,
			})
		},
		async confirm() {
			if (this.$refs.linkingForm.validate()) {
				const result = await sendCommand('ConfirmArticleImport', {
					articleImportId: this.articleImportId,
				})
				if (result.success) {
					this.$emit('continue')
				}
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.import-wrapper {
	overflow-x: scroll;
}

.import-table {
	border-collapse: collapse;

	th,
	td {
		padding: 2px 4px;
		border-width: 1px 0;
		border-style: solid;
		border-color: #bdbdbd;
	}

	td {
		max-width: 150px;
		white-space: nowrap;
		overflow: hidden;
	}

	thead th {
		min-width: 150px;
		font-weight: normal;
		text-align: left;
	}

	tr td:nth-child(even),
	tr th:nth-child(even) {
		background-color: #eeeeee;
	}

	tr.preview-header th {
		font-weight: 600;
	}
}

.excluded {
	text-decoration: line-through;
}
</style>
